import { Container, SimpleGrid, Card, Image, Text, Badge, Group, Stack } from '@mantine/core';

interface Project {
    title: string;
    description: string;
    imageUrl: string;
    tags: string[];
}

const projects: Project[] = [
    {
        title: "Project 1",
        description: "A brief description of your first project. Explain what it does and what technologies you used.",
        imageUrl: "/path/to/project1-image.jpg",
        tags: ["React", "TypeScript", "Node.js"]
    },
    // Add more projects here
];

export default function Projects() {
    return (
        <Container size="xl" py="xl">
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
                {projects.map((project, index) => (
                    <Card key={index} shadow="sm" padding="lg" radius="md" withBorder>
                        <Card.Section>
                            <Image
                                src={project.imageUrl}
                                height={160}
                                alt={project.title}
                            />
                        </Card.Section>

                        <Stack mt="md" mb="xs">
                            <Text fw={500} size="lg">{project.title}</Text>
                            <Text size="sm" c="dimmed">
                                {project.description}
                            </Text>
                            <Group gap="xs">
                                {project.tags.map((tag, tagIndex) => (
                                    <Badge key={tagIndex} color="blue" variant="light">
                                        {tag}
                                    </Badge>
                                ))}
                            </Group>
                        </Stack>
                    </Card>
                ))}
            </SimpleGrid>
        </Container>
    );
} 